import * as Cache from '@/utils/tools/cache'

const state = () => ({
  cname: Cache.get('cname') ? Cache.get('cname') : ''
})

const mutations = {
  SET_CNAME: (state, name) => {
    state.cname = name
    Cache.set('cname', name)
  }
}

const actions = {
  setCname({ commit }, name) {
    commit('SET_CNAME', name)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
